(function () {
  'use strict';

  function preloadSlideImages(root) {
    root.querySelectorAll('.hww-section__card-image img').forEach(function (img) {
      img.loading = 'eager';
      if (img.complete) return;
      var src = img.currentSrc || img.src;
      if (src) {
        var loader = new Image();
        loader.src = src;
      }
      if (img.decode) {
        img.decode().catch(function () {});
      }
    });
  }

  function initHowItWorksV2(root) {
    if (!root || root.dataset.hwwInit === 'true') return;
    root.dataset.hwwInit = 'true';

    var swiperEl = root.querySelector('[data-hww-swiper]');
    var tabs = Array.from(root.querySelectorAll('[data-hww-tab]'));
    var cards = Array.from(root.querySelectorAll('[data-hww-card]'));

    if (!swiperEl || !tabs.length || typeof Swiper === 'undefined') return;

    preloadSlideImages(root);

    if (swiperEl.swiper) {
      swiperEl.swiper.destroy(true, true);
    }

    var swiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 16,
      loop: false,
      speed: 450,
      simulateTouch: true,
      allowTouchMove: true,
      touchStartPreventDefault: false,
      watchOverflow: false,
      grabCursor: true,
      breakpoints: {
        0: {
          slidesPerView: 1.2
        },
        640: {
          slidesPerView: 2.15
        },
        769: {
          slidesPerView: 2.5
        },
        992: {
          slidesPerView: 3
        },
        1200: {
          slidesPerView: 3
        }
      }
    });

    function setActive(index) {
      tabs.forEach(function (tab, i) {
        tab.classList.toggle('is-active', i === index);
        tab.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });

      cards.forEach(function (card, i) {
        card.classList.toggle('is-active', i === index);
      });
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        if (index === swiper.activeIndex) return;
        setActive(index);
        swiper.slideTo(index);
      });
    });

    swiper.on('slideChange', function () {
      setActive(swiper.activeIndex);
    });

    setActive(swiper.activeIndex);
  }

  function boot() {
    if (typeof Swiper === 'undefined') return;
    document.querySelectorAll('[data-hww-section]').forEach(initHowItWorksV2);
  }

  function waitForSwiper(callback) {
    if (typeof Swiper !== 'undefined') {
      callback();
      return;
    }

    var tries = 0;
    var timer = setInterval(function () {
      if (typeof Swiper !== 'undefined' || ++tries > 40) {
        clearInterval(timer);
        if (typeof Swiper !== 'undefined') callback();
      }
    }, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      waitForSwiper(boot);
    });
  } else {
    waitForSwiper(boot);
  }

  document.addEventListener('shopify:section:load', function (e) {
    waitForSwiper(function () {
      var root = document.getElementById('hww-' + e.detail.sectionId);
      if (root) {
        root.dataset.hwwInit = 'false';
        initHowItWorksV2(root);
      }
    });
  });
})();
